import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { USER_API_URL } from "../../../config";
import { LocalizationSettings } from "../types";

export const useLocalizationSettings = () => {
  return useQuery({
    queryKey: ["localization-settings"], // Key used to cache the request
    queryFn: ({ signal }) =>
      axios
        .get(
          `${USER_API_URL}/waves-user-manager-api/v1/settings/localization`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as LocalizationSettings;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
